import { useState } from 'react';
import { useSelector } from 'react-redux';
import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import ContentProviderForm from './ContentProviderForm';

const ContentProviderPanel = props => {
  const {
    contentProvider,
    action,
    onDestroy
  } = props;

  // if we're creating a job then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  const deleteContentProvider = () => onDestroy(contentProvider.id);

  let cards = [
    {
      label: 'Delete Content Provider',
      message: 'Deleting a content provider will remove the account\'s ability to complete jobs under this lab account.',
      actions: [
        { label: 'Delete Content Provider', callback: deleteContentProvider }
      ]
    }
  ]

  return <ResourceModalPanel cards={cards} />;
}

const ContentProviderModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    onDestroy,
    contentProvider
  } = props;

  const action = contentProvider ? 'update' : 'create';

  let title, subTitle = null;
  if (action === 'update') {
    title = contentProvider.account_name;
    subTitle = contentProvider.client_provider_id;
  } else {
    title = 'New Content Provider';
  }

  const onSubmit = params => onFormSubmit(action, params);

  const account = useSelector(state => state.portalReducer.account);

  return (
    <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
      <ContentProviderPanel {...{ contentProvider, action, onDestroy }} />
      <ContentProviderForm {...{
        contentProvider, action, onClose, onSubmit, account
      }} />
    </ResourceModal>
  );
}

export default ContentProviderModal;
